import { type } from "arktype";
export const onboardingAnswersSchema = type({
    goals: "Record<string, boolean>",
    hearAboutUs: "Record<string, boolean>",
    "checkinFrequency?": "string",
});
//# sourceMappingURL=education.models.js.map